var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"text-2xl md:text-3xl",class:_vm.classStyles['text-main_color-500']},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }